export const pxToRem = (px: number) => `${px / 16}rem`;

export const APPLICATION_SPACING = (number: number) => pxToRem(number * 8);

export const SPECIFIC_SPACING = {
  "4px": pxToRem(4) as any,
  "12px": pxToRem(12) as any,
};
